import React, { useState, useEffect } from 'react';

const SimpleLocation = () => {
    const [position, setPosition] = useState({ lat: null, lng: null });
    const [error, setError] = useState(null);

    useEffect(() => {
        const getLocation = () => {
            if (!navigator.geolocation) {
                setError("المتصفح لا يدعم تحديد الموقع");
                return;
            }

            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    setPosition({
                        lat: pos.coords.latitude,
                        lng: pos.coords.longitude,
                    });
                    setError(null);
                },
                (err) => {
                    // عرض رسالة خطأ واضحة بدلاً من الانتظار للأبد
                    setError(`فشل جلب الموقع: ${err.message}`);
                },
                {
                    enableHighAccuracy: true,
                    timeout: 10000, // الانتظار لمدة 10 ثوانٍ كحد أقصى
                    maximumAge: 0   // عدم استخدام موقع مخزن سابقاً
                }
            );
        };

        getLocation();
    }, []);

    return (
        <div style={{ padding: '20px', fontFamily: 'sans-serif', direction: 'rtl', textAlign: 'center' }}>
            <h3>إحداثيات الجهاز</h3>
            <hr />

            {error && (
                <div style={{ color: 'red', backgroundColor: '#fee2e2', padding: '10px', borderRadius: '5px' }}>
                    {error}
                    <br />
                    <button onClick={() => window.location.reload()} style={{ marginTop: '10px' }}>
                        تحديث الصفحة والمحاولة مجدداً
                    </button>
                </div>
            )}

            {position.lat && position.lng ? (
                <div style={{ fontSize: '1.2rem', marginTop: '20px' }}>
                    <p><strong>خط العرض:</strong> {position.lat}</p>
                    <p><strong>خط الطول:</strong> {position.lng}</p>
                </div>
            ) : (
                !error && <p>⏳ جاري جلب الإحداثيات... تأكد من تفعيل GPS والموافقة على الطلب</p>
            )}
        </div>
    );
};

export default SimpleLocation;